import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilBell, cilEnvelopeOpen, cilList, cilMenu } from "@coreui/icons";

import { VendorHeaderDropdown } from "./header/index";
import { logo } from "./assets/brand/logo";
import VendorBreadcrumb from "./ManagerBreadcrumb";
import { VendorReducer } from "shared/redux/reducers/vendor/VendorReducer";
import DesktopLanguageSwitcher from "components/countryFlag/DesktopLanguageSwitcher";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import MobileLanguageSwitcher from "components/countryFlag/MobileLanguageSwitcher";
import style from "./ManagerHeader.module.css";
import AdminIcon from "components/icons/AdminIcon";
import { adminRequester } from "App";
import P from "components/P";

const ManagerHeader = () => {
  const [user, setUser] = useState();
  const [isMounted, setMounted] = useState(false);
  // const { isMobile } = useContext(BrowserDetectContext);
  const isMobile = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const sidebarShow = useSelector((state) => state.sidebarShow)
  const { sidebarShow } = useSelector((state) => ({
    sidebarShow: state.vendor.sidebarShow,
  }));

  const onSidebarTogglerClick = () => {
    dispatch(VendorReducer.actions.toggleSideBar(!sidebarShow));
  };
  useEffect(() => {
    if (!isMounted) {
      adminRequester.getCurrentUser((result) => setUser(result.user));
    }
  }, [isMounted]);
  useEffect(() => {
    setMounted(true);
  }, []);
  const date = new Date();
  const dateText = `${date.getFullYear()}년 ${(
    date.getMonth() + 1
  ).toLocaleString("ko", {
    minimumIntegerDigits: 2,
  })}월 ${date.getDate().toLocaleString("ko", { minimumIntegerDigits: 2 })}일`;
  return (
    <CHeader position="sticky" style={{ height: !isMobile && "128px" }}>
      <CContainer fluid>
        {isMobile && (
          <CHeaderToggler className="ps-1" onClick={onSidebarTogglerClick}>
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
        )}
        {/* <CHeaderBrand className="mx-auto d-md-none" to="/"> */}
        {/* 로고자리 */}
        {/* <CIcon icon={logo} height={48} alt="Logo" /> */}
        {/* </CHeaderBrand> */}
        {isMobile ? (
          <>
            <CHeaderNav className="d-none d-md-flex me-auto">
              {/* <CNavItem>
            <CNavLink to="/vendor" component={NavLink}>
              대시보드
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Settings</CNavLink>
          </CNavItem> */}
            </CHeaderNav>
            <CHeaderNav>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilBell} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilList} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilEnvelopeOpen} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <MobileLanguageSwitcher />
              </CNavItem>
            </CHeaderNav>
            <CHeaderNav className="ms-3">
              <VendorHeaderDropdown />
            </CHeaderNav>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <CHeaderNav className="pt-3 pb-3">
              <CNavItem className="me-auto">
                <select
                  onChange={(e) => (window.location.href = e.target.value)}
                  value={-1}
                >
                  <option value={-1} disabled>
                    바로가기
                  </option>
                  <option value="https://www.worldvape.co.kr/">
                    월드베이프 온라인몰
                  </option>
                </select>
              </CNavItem>
              {/* <CNavItem>
                <AdminIcon
                  name="web"
                  height={28}
                  style={{ marginLeft: 16, cursor: "pointer" }}
                  onClick={() => {
                    window.sessionStorage.setItem("mode", 1);
                    window.dispatchEvent(new Event("storage"));
                  }}
                />
              </CNavItem>
              <CNavItem className="d-none d-md-flex me-auto">
                <AdminIcon
                  name="mobile"
                  height={28}
                  style={{ marginLeft: 16, cursor: "pointer" }}
                  onClick={() => {
                    window.sessionStorage.setItem("mode", 2);
                    window.dispatchEvent(new Event("storage"));
                  }}
                />
              </CNavItem> */}
              <CNavItem>
                <P weight="bold" color="green">{`${
                  user?.first_name ? user.first_name : ""
                }${user?.first_name && user?.last_name ? " " : ""}${
                  user?.last_name ? user.last_name : ""
                }`}</P>
              </CNavItem>
              {/* <CNavItem>
                <P color="red"> {`(${user?.email?.split("@")?.[0]})`}</P>
              </CNavItem> */}
              <CNavItem>
                <P weight="bold"> 님</P>
              </CNavItem>

              {/* <CNavItem>
                <P
                  weight="bold"
                  margin="0px 0px 0px 16px"
                  hover
                  cursor
                  onClick={() => navigate("/admin")}
                >
                  고객센터
                </P>
              </CNavItem> */}
            </CHeaderNav>
            {/* <CHeaderNav style={{ marginTop: "20px" }}> */}
            <CHeaderNav className="pt-3">
              <CNavItem className="me-auto">
                <P weight="bold" size={20}>
                  {dateText}
                </P>
              </CNavItem>
              <CNavItem>
                {/* <CNavLink href="#">
                  <AdminIcon name={"alert"} size={20} />
                </CNavLink> */}
              </CNavItem>
              <CNavItem>
                {/* <CNavLink href="#">
                  <AdminIcon name={"chat"} size={20} />
                </CNavLink> */}
              </CNavItem>
              <CNavItem>
                <P
                  padding="0px 0px 0px 8px"
                  margin="0px 0px 0px 16px"
                  onClick={() => {
                    adminRequester.Logout(() => {
                      const isAdmin = window.location.pathname.includes(
                        "admin"
                      );
                      navigate(isAdmin ? "/admin/login" : "/vendor/login");
                    });
                  }}
                  hover
                  cursor
                  weight="bold"
                >
                  로그아웃
                </P>
              </CNavItem>
            </CHeaderNav>
          </div>
        )}
      </CContainer>
      {/* <CHeaderDivider /> */}
      {/* <CContainer fluid>
        <VendorBreadcrumb />
      </CContainer> */}
    </CHeader>
  );
};

export default ManagerHeader;
